import React from "react";
import EnquiryForm from "./EnquiryForm";

const ContactModal = ({ isOpen, onClose, onSuccess }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-xl rounded-lg bg-white p-8 shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold uppercase text-blue-900">
              Get In Touch With Us
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Share your requirement and our team will get back to you shortly.
            </p>
          </div>
          <button
            type="button"
            className="text-3xl leading-none text-gray-500 transition hover:text-gray-700"
            onClick={onClose}
            aria-label="Close contact form"
          >
            &times;
          </button>
        </div>

        <div className="mt-6">
          <EnquiryForm
            onSuccess={(payload) => {
              if (typeof onSuccess === "function") {
                onSuccess(payload);
              }
            }}
            submitLabel="Send Message"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
